import { STORAGE_KEY } from 'acr_ui/sources/components/constants';
import { acrDatasourcesReducer } from 'acr_ui/sources/components/reducers';
import { combineReducers } from 'redux';

import { aiNarrativeReducer } from 'src/redux/aiNarrative/slice';
import { aiPromptTemplatesReducer } from 'src/redux/aiNarrative/templatesSlice';
import { authReducer } from 'src/redux/auth/reducers';
import { componentSignalsReducer } from 'src/redux/componentSignals/reducers';
import { routesConfigReducer } from 'src/redux/routesConfig/reducers';
import { viewData } from 'src/redux/viewData/reducer';
import { viewState } from 'src/redux/viewState/reducer';

const ACRApp = combineReducers({
  routesConfig: routesConfigReducer,
  auth: authReducer,
  viewData,
  viewState,
  componentSignals: componentSignalsReducer,
  aiNarrative: aiNarrativeReducer,
  aiPromptTemplates: aiPromptTemplatesReducer,
  [STORAGE_KEY]: acrDatasourcesReducer,
});

export default ACRApp;
